import { z } from "zod";

export enum AppId {
  SongtradrOne = "songtradr-one",
  SongtradrStudio = "songtradr-studio",
}

export const AppIdSchema = z.nativeEnum(AppId);
